export const CompanyGroupStatus = {
    OK: 'OK',
    TRIAL: 'TRIAL',
    PENDING_PAYMENT: 'PENDING_PAYMENT'
}